/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../cart-service-apis/restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart/subcart';

/**
 * addToCart
 * url - /checkout/{apiVersion}/cart/subcart?brand={brandId}
 *
 * @param {Object} args
 * @param {String} args.env
 * @param {string} args.jwtToken
 * @param {array} args.products
 */
const externalCartAddToCart = ({ env, jwtToken, cartData }) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    return restClient.postRequest(envObj, RESOURCE_PAGE_CARTSERVICE, jwtToken, cartData)
        .then((response) => response);
};

export default externalCartAddToCart;
